export const DEFAULT_DEBOUNCE_TIME = 1000;
export const DEFAULT_MIN_SEARCH_CHARACTERS = 3;
